import ApolloErrorBoundary from '@components/ApolloErrorBoundary';
import ModalActions, { type ModalActionsProps } from '@components/modal/ModalActions';
import ModalContent from '@components/modal/ModalContent';
import { Box, Skeleton } from '@mui/material';
import { Suspense, type FC, type PropsWithChildren } from 'react';

export type TabProps = {
  userId: number;
  onClose: () => void;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};

export interface TabContentProps extends PropsWithChildren {
  slotProps?: {
    modalActions?: ModalActionsProps;
  };
}

export const TabContent: FC<TabContentProps> = ({ children, slotProps }) => {
  return (
    <>
      <ModalContent bottomDivider>
        <Box maxWidth="lg" height="55dvh" overflow="auto" mx="auto" pt={2}>
          {children}
        </Box>
      </ModalContent>
      {slotProps?.modalActions && <ModalActions {...slotProps.modalActions} />}
    </>
  );
};

const TabFallback: FC<Pick<TabProps, 'onClose'>> = ({ onClose }) => {
  return (
    <TabContent
      slotProps={{
        modalActions: {
          onClose,
        },
      }}
    >
      <Skeleton height="100%" variant="rounded" />
    </TabContent>
  );
};

export const TabSuspenseWrapper: FC<
  PropsWithChildren<{
    onClose: () => void;
  }>
> = ({ children, onClose }) => {
  return (
    <ApolloErrorBoundary variant="modal">
      <Suspense fallback={<TabFallback onClose={onClose} />}>{children}</Suspense>
    </ApolloErrorBoundary>
  );
};
